module.exports = {
  create: '创建',
  update: '编辑',
  delete: '删除',
  delete_confirm: '确认是否删除？',
  confirm: '确认',
  search: '搜索',
  active: '操作',
  more: '更多',
  excel: '导出表格',
  
  register: {
    submit: '注册',
    button: '没有帐号？注册新用户',
    back: '已有帐号？前往登陆'
  },
  
  home: {
    hello: '欢迎使用',
    ticket: '发票数量',
    user_bill_post: '待处理帐单',
    user_bill_ok: '完成帐单',
    time: ['日', '月'],
    cex_order: 'Cex订单',
    cex_order_pay: '待确认',
    cex_order_ok: '已下单',
    cex_order_no: '已退款',
    user_log: '资金变动',
    user_log_money: '充入金额',
    user_log_out: '使用金额'
  },
  
  user: {
    username: '用户帐号',
    password: '登陆密码',
    number: '物流编号',
    money: '余额',
    money_day: '结算周期',
    money_day_text: ['充值用户', '周结用户', '月结用户'],
    type: '用户类型',
    type_text: ['个人', '企业'],
    type_data: [{
      name: '姓名',
      phone: '电话',
      email: '邮箱',
      code: '居留号'
    }, 
    {
      name: '公司名称',
      phone: '公司电话',
      email: '公司邮箱',
      code: '税号'
    }],
    country: '国家',
    city: '城市',
    area: '地区',
    address: '详细地址',
    address_code: '门牌号',
    zip: '邮编',
    bank: '银行',
    bank_code: '银行帐号',
    bank_name: '银行帐户名',
    ticket: '票务',
    ticket_text: ['无', '发票用户'],
    cex_level: 'Cex等级',
    cex_codigo: 'Cex客户帐号',
    cex_pdf_type: 'Cex打印格式',
    cex_pdf_type_text: {
      1: 'A6打印',
      3: 'A4打印'
    }
  },
  
  user_log: {
    money: '金额',
    current: '剩余',
    type: '日志类型',
    type_text: ['全部', '在线支付'],
    money_type: '变动类型',
    money_type_text: ['减少', '增加'],
    content: '描述',
    created_at: '变动时间',
    
    pay: {
      title: '在线充值',
      money: '充值金额',
      redsys: 'Redsys支付',
      success: '您是否已完成支付？'
    }
  },
  
  user_bill: {
    title: '帐单',
    money: '金额',
    created_at: '时间',
    status: '状态',
    status_text: ['等待', '完成']
  },
  
  ticket: {
    before_money: '税前',
    tax: '税率',
    tax_money: '税价',
    money: '税后',
    created_at: '发票日期',
    active_pdf: '发票PDF'
  },
  
  address: {
    type: '常用',
    name: '姓名',
    contact: '联系人',
    phone: '电话',
    email: 'E-mail',
    address: '详细地址',
    number: '街道号',
    house: '门牌号',
    zip: '邮编',
    city: '城市',
    created_at: '时间',
    active_type: '常用地址',
    active_address: '选择地址',
    active_create: '保存地址',
    active_update: '更新地址'
  },
  
  cex: {
    title: {
      cex: '选择线路',
      bultos: '包裹信息',
      sender: '发件人',
      receive: '收件人'
    },
    bultos: '总包裹数',
    kilos: '总重量 (Kg)',
    take: '通知取件',
    take_text: {
      n: '不通知',
      s: '通知'
    },
    seguro: '保险',
    reembolso: '代收款',
    refCliente: '参考号',
    observac: '备注',
    
    insure: '保险手续费',
    collect: '代收款手续费',
    addPrice: '续重价',
    addWeight: '续重 (Kg)',
    price: '单价',
    money: '总价格',
    button_order: '预备下单',
    button_order_ok: '确认下单',
    button_tool: '添加包裹',
    
    tool: {
      title: '包裹计算器',
      c: '长(Cm)',
      k: '宽(Cm)',
      g: '高(Cm)',
      z: '重量(Kg)',
      weight: '包裹重量',
      volume: '体积重量',
      button: '计算包裹'
    },
    
    list: {
      tab0: '预备单',
      tab1: '今日订单',
      active_order: '确认',
      active_no: '关闭',
      active_pdf: 'PDF下载',
      button_active: '操作',
      button_ok: '全部确认',
      button_ok_message: '操作全部确认?',
      button_no: '全部关闭',
      button_no_message: '操作全部关闭?',
      button_pdf: '打包PDF',
      loading: '处理中，请在今日订单中查看'
    },
    
    query: {
      title: '订单跟踪',
      message: '支持批量查询，一行一个运单号',
      button: '查询',
      code: '运单号',
      status: '跟踪状态',
      status_time: '状态时间'
    }
  },
  
  cex_order: {
    name: '目的地',
    count: '包裹数',
    weight: '重量',
    price: '单价',
    add_weight: '续重',
    total_weight: '总重量',
    add_price: '续重价',
    collect: '代收款',
    insure: '保险',
    cost: '手续费',
    money: '总价',
    waybill: '运单号',
    number: '物流编号',
    data_name: '收件姓名',
    data_phone: '收件电话',
    take: '取件',
    take_code: '取件单号',
    take_text: ['否', '是'],
    remarks: '运单备注',
    ref: '参考号',
    pdf: 'PDF运单',
    status: '状态',
    status_text: ['待确认', '已下单', '已退款'],
    data: '接口数据',
    message: '接口信息',
    track: '跟踪状态',
    track_breakdown: '故障状态',
    created_at: '时间',
    active_no: '退款',
    active_no_message: '确认退款此订单？'
  },
  
  cex_take: {
    name: '发件人',
    code: '取件单号',
    date: '取件日期',
    time: '取件时间',
    remarks: '备注',
    data: '接口数据',
    status: '状态',
    status_text: ['已通知', '已取消'],
    created_at: '时间',
    active_no: '取消取件',
    active_no_message: '确认取消取件？',
    
    create: {
      title: '通知取件',
      cex: '发件线路',
      date: '取件日期',
      time: '取件时间段',
      address: '取件地址',
      observ: '备注',
    }
  }
}